module.exports = __webpack_public_path__ + "static/media/clothing.6a60a4ad.webp";